(function lpbPriorityOne() {
  const normalize = (text) =>
    (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const setupExternalSocialLinks = () => {
    const socialHosts = ['instagram.com', 'facebook.com', 'tiktok.com', 'youtube.com', 'youtu.be', 'x.com', 'twitter.com'];

    document.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (!socialHosts.some((host) => url.hostname === host || url.hostname.endsWith(`.${host}`))) return;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      } catch (_error) {
        return;
      }
    });
  };

  const hideLegacyShopTheLook = () => {
    const main = document.querySelector('main');
    if (!main) return;

    [...main.children].forEach((section) => {
      if (section.querySelector('.lpb-look')) return;
      const text = normalize(section.textContent);
      if (!text.includes('shop the look')) return;
      if (!text.includes('selection') && !text.includes('voir tout')) return;
      section.hidden = true;
      section.setAttribute('aria-hidden', 'true');
    });
  };

  const setupAccountDebug = () => {
    if (!new URLSearchParams(window.location.search).has('lpb_account_debug')) return;
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const path = event.composedPath?.() || [];
        const interesting = target?.closest?.('a, button, shopify-account, [role="button"], [data-lpb-account-trigger]');
        if (!interesting && !path.some((node) => node instanceof Element && node.matches?.('shopify-account'))) return;

        const link = target?.closest?.('a[href]');
        console.info('[LPB account debug]', {
          target,
          control: interesting,
          href: link?.href || null,
          text: interesting?.textContent?.trim() || '',
          defaultPrevented: event.defaultPrevented,
          path: path
            .filter((node) => node instanceof Element)
            .slice(0, 8)
            .map((node) => node.tagName.toLowerCase())
        });
      },
      true
    );
  };

  const run = () => {
    setupExternalSocialLinks();
    hideLegacyShopTheLook();
  };

  setupAccountDebug();
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);
})();
